// extracted by mini-css-extract-plugin
export default {"warn-title-box":"Hw84dqKbNL8LrECyCi2P","warning-img":"ZjeCQfQCAZI06Cl_UDoS","warn-title":"UVoY7KSxMJZ5hy91fp5A"};